import HttpClient from '../HttpClient';
import HTTPResponse from '../HttpResponse';
import { Errors, ErrorResponse } from './errors';

class TimeSlot {
  private http: HttpClient;

  public constructor(http: HttpClient) {
    this.http = http;
  }

  public reserveTimeSlot = async (
    timeSlotId: string,
  ): Promise<HTTPResponse<unknown>> => {
    try {
      const url = `/timewindow/reserve/${timeSlotId}`;
      const reserveResponse = await this.http.post(url, {});

      return new HTTPResponse(reserveResponse);
    } catch (err) {
      const error: ErrorResponse = {
        status: Errors.CONFLICT,
        data: {
          statusCode: 'conflict',
        },
      };
      return new HTTPResponse('', error);
    }
  };

  public clearReservedTimeSlot = async (
    timeSlotId: string,
  ): Promise<HTTPResponse<unknown>> => {
    try {
      const url = `/timewindow/reserve/${timeSlotId}`;
      const reserveResponse = await this.http.delete(url);

      return new HTTPResponse(reserveResponse);
    } catch {
      return new HTTPResponse('');
    }
  };
}

export default TimeSlot;
